
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MENU_DISH_FRAGMENT"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"menuDish"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"titleEn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"caption"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"captionEn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"composition"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"weight"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"promoPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"portions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previewImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previewMobileImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"verticalImage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"umAlias"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subcategory_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subcategory_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cooking_time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cook_until"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"secondDishPart"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parentId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"replaceableIngredient"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"visibleStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nutrition"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"carbohydrate"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unit"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"fat"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unit"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"protein"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unit"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"calories"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unit"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"additionalDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"option_tags"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"highlight_words"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"highlight_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"highlight_description_title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"highlight_image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previewMobileAlterImage"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":952}};
    doc.loc.source = {"body":"fragment MENU_DISH_FRAGMENT on menuDish {\n    id,\n    title,\n    titleEn,\n    caption,\n    captionEn,\n    composition,\n    weight,\n    price,\n    promoPrice,\n    portions,\n    previewImage,\n    previewMobileImage,\n    verticalImage\n    umAlias,\n    category_id,\n    category_description\n    subcategory_id\n    subcategory_name\n    cooking_time\n    cook_until\n    secondDishPart,\n    parentId\n    replaceableIngredient,\n    tags {\n        id\n    },\n    visibleStatus,\n    nutrition {\n        carbohydrate {\n         title\n         value\n         unit\n        }\n        fat {\n         title\n         value\n         unit\n        }\n        protein {\n         title\n         value\n         unit\n        }\n        calories {\n         title\n         value\n         unit\n        }\n    }\n    additionalDescription,\n    option_tags,\n    highlight_words\n    highlight_description\n    highlight_description_title\n    highlight_image\n    previewMobileAlterImage,\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["MENU_DISH_FRAGMENT"] = oneQuery(doc, "MENU_DISH_FRAGMENT");
        
